import { TenantFeatureToggle, TenantType } from '@xeetr/types/enums'

import { useTenant } from '../useTenant'

export const featureTenantRestrictions: Partial<Record<TenantFeatureToggle, TenantType[]>> = {
  [TenantFeatureToggle.FOOD_EVENTS]: [TenantType.FOOD],
  [TenantFeatureToggle.WALKIN]: [TenantType.FOOD],
  [TenantFeatureToggle.CUSTOMER_ADDRESS]: [TenantType.SERVICE],
  [TenantFeatureToggle.TABLEMANAGEMENT]: [TenantType.FOOD],
  [TenantFeatureToggle.MULTIPLEBOOKEDTABLES]: [TenantType.FOOD],
  [TenantFeatureToggle.CLOSEDSOCIETY]: [TenantType.FOOD],
}

const useFeatureToggle = (allowed: TenantFeatureToggle | TenantFeatureToggle[]): boolean => {
  const { tenant } = useTenant()

  const checkFeature = (feature: TenantFeatureToggle): boolean => {
    const hasFeature =
      tenant?.features?.includes(feature) ||
      tenant?.features?.includes(TenantFeatureToggle.DEVELOPER)
    const allowedTypes = featureTenantRestrictions[feature]
    const typeAllowed =
      tenant !== undefined && (!allowedTypes || allowedTypes.includes(tenant.type))
    return !!hasFeature && typeAllowed
  }

  if (Array.isArray(allowed)) {
    return allowed.some(checkFeature)
  }
  return checkFeature(allowed)
}

export default useFeatureToggle
